export const STORAGE_USER = "minhaagenda_turma-backoffice-userdetails";

export const ROLE_ADMIN = "ADMIN";
export const ROLE_MASTER_ADMIN = "MASTER_ADMIN";
export const ROLES_ADMIN = [ROLE_ADMIN, ROLE_MASTER_ADMIN];
export const ROLE_USER = "USER";
export const ROLES_USER = [ROLE_USER];
